module.exports = __webpack_public_path__ + "static/media/ploni-ultrabold-aaa.96b47b37.woff";